import { createPaywallApi } from '@forest/paywall-core'
import { userInfoSource } from '~/store/user-info'

const DEV_PROXY = '/service'
const devOverride = import.meta.env.DEV
  ? {
      serviceBaseByServer: {
        dev: DEV_PROXY,
        staging: DEV_PROXY,
        global: DEV_PROXY,
        china: DEV_PROXY,
      },
    }
  : {}

export const api = createPaywallApi({
  userInfo: userInfoSource,
  ...devOverride,
})

export async function getCurrentUserId(): Promise<number> {
  const info = await userInfoSource.getReady()
  return info.user_id
}
